import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const staticApi = createApi({
  reducerPath: "staticApis",
  baseQuery,
  tagTypes: [
    "faq",
    "team",
    "youtube-videos",
    "reviews",
    "about",
    "contact",
    "cost-calculator",
    "orderWebsite",
  ],
  keepUnusedDataFor: 5,
  endpoints: (builder) => ({
    getFaqInfos: builder.query({
      query: () => "/faq",
      providesTags: ["faq"],
    }),
    getTeamList: builder.query({
      query: () => "/team",
      providesTags: ["team"],
    }),
    getYoutubeVideo: builder.query({
      query: () => "/youtube-videos",
      providesTags: ["youtube-videos"],
    }),
    getReviewsList: builder.query({
      query: () => "/review",
      providesTags: ["reviews"],
    }),
    getAboutInfos: builder.query({
      query: () => "/about",
      providesTags: ["about"],
    }),
    getCostCalculatorInfo: builder.query({
      query: () => "/cost-calculator",
      providesTags: ["cost-calculator"],
    }),
    orderWebsite: builder.mutation({
      query: (body) => ({
        url: "/cost-calculator",
        method: "POST",
        body,
      }),
      invalidatesTags: ["orderWebsite"],
    }),
    contactUs: builder.mutation({
      query: (body) => ({
        url: "/contact",
        method: "POST",
        body,
      }),
      invalidatesTags: ["contact"],
    }),
  }),
});

export const {
  useLazyGetFaqInfosQuery,
  useGetTeamListQuery,
  useGetYoutubeVideoQuery,
  useGetReviewsListQuery,
  useLazyGetAboutInfosQuery,
  useContactUsMutation,
  useGetCostCalculatorInfoQuery,
  useOrderWebsiteMutation,
} = staticApi;
